import React from "react";
import { FormattedMessage } from "react-intl";
import type { LandingPageConfig } from "./LandingPageConfig";
import type SubscriptionResult from "./SubscriptionResult";

export interface ISubscriptionAcknowledgementProps {
  landingPageConfig: LandingPageConfig;
  subscriptionResult: SubscriptionResult;
}

export default (props: ISubscriptionAcknowledgementProps) => {
  const { landingPageConfig, subscriptionResult } = props;
  return (
    <>
      <h2>
        {subscriptionResult.displayText ? (
          subscriptionResult.displayText
        ) : (
          <FormattedMessage id="landing.subscription.acknowledgement.thankyou" />
        )}
      </h2>

      {landingPageConfig.followUs.length > 0 &&
        landingPageConfig.followUs.map((followUs) => (
          <p key={followUs.id}>
            <a href={followUs.url} target="_blank" rel="noreferrer">
              <img src={followUs.logoUrl} style={{ width: "300px" }} />
            </a>
          </p>
        ))}
    </>
  );
};
